import Vue from 'vue'
import VueRouter from 'vue-router'
import PageNotFound from './pages/PageNotFound.vue'
import Home from './pages/Home.vue'
import Products from './pages/Products.vue'
import Cart from './pages/Cart.vue'
import Profile from './pages/Profile.vue'
import History from './pages/History.vue'
import PaymentSuccessPage from './pages/PaymentSuccessPage.vue'
import PaymentFaliPage from './pages/PaymentFaliPage.vue'
import TextPage from './pages/TextPage.vue'
import ContactUs from './pages/ContactUs.vue'





Vue.use(VueRouter)

export default new VueRouter({
	mode: 'history',
	routes: [
		//{ path: '/', redirect: '/home' },
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/Products',
			name: 'Products',
			component: Products
		},
		{
			path: '/cart',
			name: 'Cart',
			component: Cart
		},
		{
			path: '/history',
			name: 'History',
			component: History
		},
		{
			path: '/profile',
			name: 'Profile',
			component: Profile
		},
		{
			path: '/success-payment',
			name: 'PaymentSuccessPage',
			component: PaymentSuccessPage
		},
		{
			path: '/fail-payment',
			name: 'PaymentFaliPage',
			component: PaymentFaliPage
		},
		{
			path: '/contact-us',
			name: 'ContactUs',
			component: ContactUs
		},
		{
			path: '/pages/:id',
			name: 'TextPage',
			component: TextPage
		},
		{ 
			path: "*", 
			name: 'PageNotFound',
			component: PageNotFound,
			props: {title: "PageNotFound"}
		}
	]
})

